<template>
    <container-page>
        <template v-slot:header>
            <span class="titlePage" v-if="!user.CLIENTE_ID"> {{'CRM de Vendas' | translate('CRMVendas')}} </span>
            <div class="bodyPage" v-if="user.CLIENTE_ID">
                <no-adm-banner message="Área destinada a usuários Operadores!"/>
            </div>
        </template>
    </container-page>
</template>

<script>
import ContainerPage from '../../../src/components/containerPage.vue'
import NoAdmBanner from '../../../src/components/NoAdmBanner'
import { createNamespacedHelpers } from 'vuex'
const user = createNamespacedHelpers('user')

export default {
    name: 'CRMVendas',
    components: {ContainerPage, NoAdmBanner},
    data() {
        return {
        }
    },
    computed:{
        ...user.mapGetters(['user'])
    },
    methods: {
    }

}
</script>
<style scoped>
.titlePage{
    font-size: 20px;
    font-weight: 700;
}
</style>
